const moduleFiles = import.meta.glob('./**/*.js', { eager: true })
const modules = {}

Object.entries(moduleFiles).forEach(([fileName, moduleContent]) => {
    if (fileName === './index.js') return

    const path = fileName.replace(/(\.\/|\.js)/g, '')
    const [moduleName, imported] = path.split('/')

    if (!modules[moduleName]) {
        modules[moduleName] = {
            namespaced: true,
        }
    }

    if (imported) {
        modules[moduleName][imported] = moduleContent.default
    } else {
        Object.assign(modules[moduleName], moduleContent.default)
    }
})

export default modules
